import { IAggregator } from 'src/types/aggregator.types';

export const getExternalSystemName = (externalSystemId: string, aggregators: IAggregator[]) => {
  const aggregator = aggregators.find((agg) => agg.aggregatorId === externalSystemId);
  return aggregator?.name;
};
